import { useEffect, useRef } from "react";

export default function TemporarySelectionCheckbox({
  checked,
  indeterminate = false,
  onChange,
  label,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <input
      ref={inputRef}
      type="checkbox"
      checked={checked}
      aria-label={label}
      onClick={(event) => event.stopPropagation()}
      onChange={(event) => {
        event.stopPropagation();
        onChange();
      }}
      style={{ width: "16px", height: "16px", cursor: "pointer" }}
    />
  );
}
